import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, BgLoader, UiInput, UiToggle, OverlayLoader } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";


const VoucherSeriesModal = NiceModal.create(
  ({ id, subtitle, action, bgColor, note = "", data }) => {
    const [input, setInput] = useState(note);
    const [state, setState] = useState({ count: 0 });
    const [loader, showLoader] = useState(false);
    const modal = useModal();
    const zstate = useStore((state) => state.categories);
    const mstate = useStore((state) => state.machines);
    const setZState = useStore((state) => state.setGroups);
    const schema = yup.object().shape({
      name: yup.string().required("Enter name of voucher series"),
      type: yup.string().required("Select type"),
      auto_num: yup.bool(),

      start: yup.string().nullable().when('auto_num', {

        is: true,
        then: (rule) => rule
          .matches(/^[0-9]+$/, "Enter start number")
          .min(0, 'Negative value not allowed')

      }),




    }, []);
    const {
      register,
      handleSubmit,
      control,
      resetField,
      unregister,
      setValue,
      watch,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {
      showLoader(true);

      instance({
        method: "post",
        url: "/update_voucher_series",
        data: e,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          showLoader(false);
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            useStore.setState({ load_series: false });
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };



    const fetchData = () => {
      instance
        .get("/get_voucher_series?id=" + id)
        .then(function (response) {
          setState(response.data)
          reset(response.data.item)

        })
        .catch(function (error) { })
        .then(function () { });
    }


    useEffect(() => {
      fetchData();


    }, []);



    const handleHide = () => {
      modal.hide();
    }

    const watchAutonum = watch('auto_num')
    const watchFyPrefix = watch('fy_as_prefix')


    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Voucher Series</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={loader} />
        {state.status ? <>
          <BootstrapModal.Body>
            <form id="vsform" onSubmit={handleSubmit(onSubmitHandler)}>
              <UiSelect
                name='type'
                label="Voucher Type"
                required
                disabled={id == 'new' ? false : true}
                message={errors.type?.message}
                options={["Sales", "Purchase", "Payment", "Receipt", "Journal"]}
                {...register(`type`)}
              />
              <UiInput
                label="Name"
                type="text"
                required
                name="name"
                {...register("name")}
                message={errors.name?.message}
              />


              <UiToggle
                id="auto_num"
                name="auto_num"
                value="1"
                title="Auto Numbering"
                {...register("auto_num")}
              />

              {watchAutonum && <>
                <h5>Auto Numbering</h5>
                <div className="row">
                  <div className="col-8">
                    <UiInput
                      label="Prefix"
                      type="text"

                      disabled={watchFyPrefix ? true : false}
                      name="prefix"
                      {...register("prefix")}
                      message={errors.prefix?.message}
                    />
                  </div>
                  <div className="col-4">
                    <UiInput
                      label="Number Start from"
                      type="text"
                      required
                      name="start"
                      {...register("start")}
                      message={errors.start?.message}
                    />
                  </div>
                </div>

                <UiToggle
                  id="fy_as_prefix"
                  name="fy_as_prefix"
                  title="Use FY as Prefix"
                  {...register("fy_as_prefix", { onChange: (e) => { e.target.checked ? setValue('prefix', state.fy) : setValue('prefix', ''); } })}
                />
              </>}










              <input type="hidden" value={id} name="id" {...register("id")} />
              <Button variant="primary" type="submit">
                Save
              </Button>
            </form>
          </BootstrapModal.Body>
        </> : <BgLoader />}

      </BootstrapModal>
    );
  }
);

export default VoucherSeriesModal;
